export const capitalizeString = (stringToCapitalize: string): string =>
  stringToCapitalize.charAt(0).toUpperCase() + stringToCapitalize.slice(1);

export const roundToTwoDecimalPlaces = (number: number): number =>
  Math.round(number * 100) / 100;
